import { render } from "./OngoingComplianceForm.vue?vue&type=template&id=64ccd867&scoped=true"
import script from "./OngoingComplianceForm.vue?vue&type=script&lang=js"
export * from "./OngoingComplianceForm.vue?vue&type=script&lang=js"

import "./OngoingComplianceForm.vue?vue&type=style&index=0&id=64ccd867&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-64ccd867"]])

export default __exports__